"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'MerchantDetail',
  data: function data() {
    return {
      loading: false,
      merchantDetail: {}
    };
  },
  mounted: function mounted() {
    this.getMerchantDetail();
  },
  methods: {
    // 获取商户详情
    getMerchantDetail: function getMerchantDetail() {
      var _this = this;
      this.loading = true;
      var id = this.$route.query.id;
      if (!id) {
        this.$message.error('缺少商户ID参数');
        this.goBack();
        return;
      }

      // 调用后端API获取详情
      Promise.resolve().then(function () {
        return _interopRequireWildcard(require('@/api/rsApi'));
      }).then(function (_ref) {
        var getSupplierDetail = _ref.getSupplierDetail;
        getSupplierDetail(id).then(function (data) {
          // request拦截器已处理响应结构，直接使用data
          _this.merchantDetail = data || {};
          _this.loading = false;
        }).catch(function (error) {
          _this.$message.error(error.message || '获取详情失败');
          _this.loading = false;
        });
      });
    },
    // 返回列表
    goBack: function goBack() {
      this.$router.push('/rs/merchant');
    },
    // 获取状态类型
    getStatusType: function getStatusType(status) {
      var statusMap = {
        '签订合同': 'success',
        '洽谈中': 'warning',
        '已停用': 'danger'
      };
      return statusMap[status] || 'info';
    },
    // 获取合作状态名称
    getCooperationStatusName: function getCooperationStatusName(statusValue) {
      var cooperationStatusOptions = [{
        value: '1',
        label: '待联系'
      }, {
        value: '2',
        label: '初次联系无回复'
      }, {
        value: '3',
        label: '资料收集'
      }, {
        value: '4',
        label: '商务洽谈'
      }, {
        value: '5',
        label: '签订合同'
      }, {
        value: '6',
        label: '合同终止'
      }];
      var status = cooperationStatusOptions.find(function (item) {
        return item.value === statusValue;
      });
      return status ? status.label : statusValue;
    },
    // 获取开票方式名称
    getInvoiceMethodName: function getInvoiceMethodName(invoiceValue) {
      var invoiceOptions = [{
        value: '1',
        label: '无票'
      }, {
        value: '2',
        label: '普票'
      }, {
        value: '3',
        label: '专票'
      }, {
        value: '4',
        label: '混合票种'
      }];
      var invoice = invoiceOptions.find(function (item) {
        return item.value === invoiceValue;
      });
      return invoice ? invoice.label : invoiceValue;
    },
    // 获取调价方式名称
    getAdjustTypeName: function getAdjustTypeName(adjustValue) {
      var adjustOptions = [{
        value: 0,
        label: '不调价'
      }, {
        value: 1,
        label: '按比例'
      }];
      var adjust = adjustOptions.find(function (item) {
        return item.value === adjustValue;
      });
      return adjust ? adjust.label : adjustValue === 0 ? '不调价' : '按比例';
    },
    // 获取调价范围名称
    getAdjustRangeName: function getAdjustRangeName(rangeValue) {
      var rangeOptions = [{
        value: 1,
        label: '不超过原价'
      }, {
        value: 2,
        label: '不限制'
      }];
      var range = rangeOptions.find(function (item) {
        return item.value === rangeValue;
      });
      return range ? range.label : '-';
    },
    // 格式化调价比例显示（后端返回小数，前端也显示小数）
    formatAdjustRate: function formatAdjustRate(rate) {
      if (rate === null || rate === undefined || rate === '') {
        return '-';
      }
      // 后端返回小数，前端也直接显示小数，最多保留两位小数
      return Number(rate).toFixed(2);
    },
    // 格式化金额
    formatAmount: function formatAmount(amount) {
      if (!amount) return '0.00';
      return Number(amount).toLocaleString('zh-CN', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    }
  }
};